import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  Dropdown,
  Container,
  Legend,
  BaseControl,
  Textbox,
  Custom,
  TipoControl,
  Option,
  DateTimePicker,
  ValoresMaestraPorDefectoSeletor
} from '@app/shared';

@Injectable()
export class DefaultValueMasterFormService {
  constructor() { }

  /**
   * Crea el formulario de creacion o edicion de las condiciones
   *
   * @param {*} template
   * @param {*} options
   * @param {ValoresMaestraPorDefectoSeletor} [defaultValue]
   * @returns {BaseControl<any>[]}
   * @memberof DefaultValueMasterFormService
   */
  getFormDefaultValuesMaster(
    template: any,
    options: any,
    defaultValue?: ValoresMaestraPorDefectoSeletor, 
    parameters?: any
  ): BaseControl<any>[] {
    const controlSpecific = this.getControlSpecific(
      defaultValue ? defaultValue.valor : null,
      template,
      parameters
    );
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'cboColumn',
        order: 1,
        label: 'Columna:',
        value: defaultValue ? defaultValue.columna : null,
        template: template['select'],
        options: options['columnsMaster'] ? options['columnsMaster'] : [],
        placeholder: 'Seleccione la columna ha aplicar el valor por defecto.',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Custom({
        key: 'cboTipoValor',
        label: 'Tipo valor:',
        value: defaultValue ? defaultValue.tipo_valor : null,
        template: template['select'],
        options: [
          {key: 'Formulario', value: 'formulario'},
          {key: 'Específico', value: 'especifico'}
        ],
        size: 'col-md-4',
        placeholder: 'Seleccionar la forma donde se encuentra el campo ha aplicar el valor por defecto.',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Container({
        class: 'form-row form-check form-check-inline col-12',
        order: 2,
        controls: [
          new Custom({
            key: 'cboForm',
            label: 'Forma:',
            value: defaultValue ? defaultValue.forma : null,
            template: template['select'],
            options: options['forms'] ? options['forms'] : [],
            size: 'col-md-4',
            placeholder: 'Seleccionar la forma donde se encuentra el campo que contiene el valor por defecto.',
            validations: {
              validators: [Validators.required]
            },
            condictions: [
              {
                campoDepende: 'cboTipoValor',
                siEs: 'Igual',
                valor: 'formulario',
                accion: 'Mostrar'
              }
            ]
          }),
          new Custom({
            key: 'cboFormulario',
            label: 'Formulario:',
            value: defaultValue ? defaultValue.formulario : null,
            template: template['select'],
            options: options['formFormularios'] ? options['formFormularios'] : [],
            size: 'col-md-4',
            placeholder: 'Seleccionar el formulario donde se encuentra el campo que contiene el valor por defecto.',
            validations: {
              validators: [Validators.required]
            },
            condictions: [
              {
                campoDepende: 'cboTipoValor',
                siEs: 'Igual',
                valor: 'formulario',
                accion: 'Mostrar'
              }
            ]
          }),
          new Custom({
            key: 'cboField',
            label: 'Campo:',
            value: defaultValue ? defaultValue.campo : null,
            template: template['select'],
            options: options['fields'] ? options['fields'] : [],
            size: 'col-md-4',
            placeholder: 'Seleccionar el campo que contiene el valor por defecto',
            describe: 'Solo muestra los campos del mismo tipo que la columna seleccionada.',
            validations: {
              validators: [Validators.required]
            },
            condictions: [
              {
                campoDepende: 'cboTipoValor',
                siEs: 'Igual',
                valor: 'formulario',
                accion: 'Mostrar'
              }
            ]
          }),
        ]
      }),
      controlSpecific,
      new Textbox({
        key: 'chkBloquear',
        order: 5,
        label: 'Bloquear',
        value: defaultValue ? defaultValue.bloquear : false,
        type: 'checkbox',
      })
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  private getControlSpecific(value: any, template: any, parameters?: any): BaseControl<any> {
    let control: BaseControl<any>;
    if (!parameters) {
      control = new Textbox({
        key: 'txtValor',
        order: 5,
        label: 'Valor específico:',
        value: value ? value : null,
        placeholder: 'Ingrese el valor ha aplicar por defecto.',
        validations: {
          validators: [Validators.required]
        },
        condictions: [
          {
            campoDepende: 'cboTipoValor',
            siEs: 'Igual',
            valor: 'especifico',
            accion: 'Mostrar'
          }
        ]
      });
    } else {
      switch (parameters['type']) {
        case 'ngSelect':
          control = new Custom({
            key: 'txtValor',
            order: 5,
            label: 'Valor específico:',
            value: value ? value : null,
            template: template['select'],
            options: parameters['options'],
            size: 'col-md-4',
            placeholder: 'Seleccione el valor ha aplicar por defecto.',
            validations: {
              validators: [Validators.required]
            },
            condictions: [
              {
                campoDepende: 'cboTipoValor',
                siEs: 'Igual',
                valor: 'especifico',
                accion: 'Mostrar'
              }
            ]
          });
          break;
        case 'date-time-picker':
          control = new DateTimePicker({
            key: 'txtValor',
            order: 5,
            label: 'Valor específico:',
            value: value ? value : null,
            placeholder: 'DD/MM/AAAA.',
            validations: {
              validators: [Validators.required]
            },
            condictions: [
              {
                campoDepende: 'cboTipoValor',
                siEs: 'Igual',
                valor: 'especifico',
                accion: 'Mostrar'
              }
            ]
          });
          break;
        case 'checkbox':
          control = new Custom({
            key: 'txtValor',
            order: 5,
            label: 'Valor específico:',
            value: value ? value : null,
            template: template['select'],
            options: [
              {key: 'Seleccionado', value: 'seleccionado'},
              {key: 'No seleccionado', value: 'no_seleccionado'}
            ],
            size: 'col-md-4',
            placeholder: 'Seleccione el valor ha aplicar por defecto.',
            validations: {
              validators: [Validators.required]
            },
            condictions: [
              {
                campoDepende: 'cboTipoValor',
                siEs: 'Igual',
                valor: 'especifico',
                accion: 'Mostrar'
              }
            ]
          });
          break;
        default:
          control = new Textbox({
            key: 'txtValor',
            order: 5,
            label: 'Valor específico:',
            value: value ? value : null,
            placeholder: 'Ingrese el valor ha aplicar por defecto.',
            validations: {
              validators: [Validators.required]
            },
            condictions: [
              {
                campoDepende: 'cboTipoValor',
                siEs: 'Igual',
                valor: 'especifico',
                accion: 'Mostrar'
              }
            ]
          });
          break;
      }
    }
    return control;
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/default-values-master/shared/default-values-master.form.service.ts